@if (!isValid) {
  <div class="mobi-ui-card-silent mobi-ui-ink-yellow">
    <div class="mobi-ui-text-block-major">
      <mobi-ui-icon-major name="warning" />
      <div class="mobi-ui-text-block-content-major">
        <span class="mobi-ui-text-block-title-major">
          {{
            'calculation_error_label'
              | texts
                : {
                    context: 'errors',
                    default: 'Berechnung fehlgeschlagen',
                  }
          }}
        </span>
        @if (calcResult?.error) {
          {{ calcResult.error }}
        } @else {
          {{
            'calculation_error'
              | texts
                : {
                    context: 'errors',
                    default:
                      'Wir konnten mit den Angaben noch kein Angebot rechnen. Bitte überprüfen Sie die Eingaben.',
                  }
          }}
        }
      </div>
    </div>
  </div>
}
@if (element && isValid) {
  <div
    class="mobi-ui-card-major mobi-ui-relative mobi-ui-padding-b-xl"
    [class.mobi-ui-ink-black]="isSummary"
    [class.mobi-ui-ink-default]="!isSummary"
  >
    <mobi-ui-icon-inkable-major
      class="mobi-ui-slot-major is-top-left-inner mobi-ui-text-inked mobi-ui-ink-default"
      name="inkable_shield"
      size="xl"
    ></mobi-ui-icon-inkable-major>
    <div class="mobi-ui-card-content-major mobi-ui-margin-t-sm">
      @if (render) {
        @if (taxCalculators.includes(plugin)) {
          <h4 class="mobi-ui-font-size-400">
            @if (!isDealer) {
              <span class="block font-bold mobi-ui-font-size-50 mb-2 text-black">
                {{ 'your' | texts: { context: 'primcalc', default: 'Ihre' } }}
              </span>
            }
            {{ 'insurance' | texts: { context: 'primcalc', default: 'Versicherung' } }}
          </h4>
        }

        @if (isValid && calcResult && plugin === 'uvg_prime_calc') {
          <webform-calc-uvg
            #calc
            [formId]="formId"
            [result]="calcResult"
            [formData]="formData"
          ></webform-calc-uvg>
        }
        @if (isValid && calcResult && plugin === 'bike_prime_calc') {
          <webform-calc-bike
            #calc
            [formId]="formId"
            [result]="calcResult"
            [formData]="formData"
          ></webform-calc-bike>
        }
        @if (isValid && calcResult && plugin === 'cyber_prime_calc') {
          <webform-calc-cyber
            #calc
            [formId]="formId"
            [result]="calcResult"
            [formData]="formData"
          ></webform-calc-cyber>
        }

        @if (isValid && calcResult && plugin === 'household_goods_calc') {
          <webform-calc-household-goods
            #calc
            [formId]="formId"
            [result]="calcResult"
            [formData]="formData"
          ></webform-calc-household-goods>
        }

        @if (isValid && calcResult && plugin === 'mortgage_calc') {
          <webform-calc-mortgage
            #calc
            [formId]="formId"
            [result]="calcResult"
            [formData]="formData"
          ></webform-calc-mortgage>
        }

        @if (isValid && calcResult && taxCalculators.includes(plugin)) {
          <div class="mobi-ui-font-size-50 md:-mt-[20px] mobi-ui-ink-default">
            <button
              (click)="taxOpen = !taxOpen"
              class="block italic mx-auto w-auto border-b-[2px] border-signature focus:!border-b-[2px]"
            >
              {{
                'more_informations'
                  | texts: { context: 'primcalc', default: 'Mehr Informationen' }
              }}
            </button>
            @if (taxOpen) {
              <div class="pt-[20px] px-[20px]">
                @if (calcResult.premium) {
                  <div class="flex items-center justify-between">
                    <span class="pr-[5px]">
                      {{
                        'net_premium'
                          | texts: { context: 'primcalc', default: 'Nettojahresprämie' }
                      }}
                    </span>
                    <span class="font-normal text-right">
                      <span class="pr-[2px]">CHF</span>
                      {{ formatNumber(calcResult.premium, '0,00.00') }}
                    </span>
                  </div>
                }
                @if (calcResult.tax) {
                  <div
                    class="flex items-center justify-between py-5px mb-[5px] mobi-ui-text-has-border"
                  >
                    <span class="pr-5px">{{
                      'tax'
                        | texts
                          : {
                              context: 'primcalc',
                              default: '+5% Eidgenössische Stempelabgabe',
                            }
                    }}</span>
                    <span class="font-normal">
                      <span class="text-10px pr-2px">CHF</span>
                      {{ formatNumber(calcResult.tax, '0,00.00') }}
                    </span>
                  </div>
                }
                @if (calcResult.annual_premium) {
                  <div class="flex items-center justify-between pt-5px">
                    <span class="pr-5px">{{
                      'annual_premium'
                        | texts: { context: 'primcalc', default: 'Jahresprämie' }
                    }}</span>
                    <span class="font-semibold">
                      <span class="text-10px pr-2px">CHF</span>
                      {{ formatNumber(calcResult.annual_premium, '0,00.00') }}
                    </span>
                  </div>
                }
              </div>
            }
          </div>
        }
      }
    </div>
    @if (action) {
      <button class="mobi-ui-btn-minor mobi-ui-margin-t-md" (click)="action()">
        {{ 'edit' | texts: { context: 'primcalc', default: 'Anpassen' } }}
      </button>
    }
  </div>
}
